import React from "react";
import { ColorContainer, ColorSelectionContainer } from "./style";

const Index = props => {
  const { colors, meta, size, selectColor, value } = props;

  const chooseColor = color => {
    selectColor(color);
  };
  return (
    <ColorSelectionContainer size={size}>
      {meta && meta.error && <div className="error">{meta.error}</div>}
      <div className="row">
        {colors.slice(0, colors.length / 2).map((color, i) => {
          return (
            <ColorContainer
              key={i}
              onClick={() => chooseColor(color)}
              color={color}
              size={size}
            >
              {value === color && (
                <i className="selected-color-icon icon mapsa-tick" />
              )}
            </ColorContainer>
          );
        })}
      </div>
      <div className="row">
        {colors.slice(-colors.length / 2).map((color, i) => {
          return (
            <ColorContainer
              key={i}
              onClick={() => chooseColor(color)}
              color={color}
              size={size}
            >
              {value === color && (
                <i className="selected-color-icon icon mapsa-tick" />
              )}
            </ColorContainer>
          );
        })}
      </div>
    </ColorSelectionContainer>
  );
};

export default Index;
